import { render, staticRenderFns } from "./TeacherSignup.vue?vue&type=template&id=07be860c&scoped=true&"
import script from "./TeacherSignup.vue?vue&type=script&lang=js&"
export * from "./TeacherSignup.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSignup.vue?vue&type=style&index=0&id=07be860c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07be860c",
  null
  
)

export default component.exports